import React, { useEffect, useState, useCallback } from 'react';
import Management from './components/VirtualComponent';
import { useGetDimension, useEditDimensions, useGetDimensionMeta } from './utils/hooks';
export const OPEN_DIMENSION_MANAGEMENT_EVENT = 'open-dimension-management';
import * as Types from './utils/types';
import { ManagementProps } from './utils/atom';
import apptracker from '@utils/sensor/apptracker';
import { EDIT_DIMENSION_COMPLETE_DIMENSION_MANAGEMENT } from '@src/utils/sensor/track';

export const DimensionManagement = () => {
  const [dimensionVisible, setDimensionVisible] = useState(false);
  const { mutateAsync: editDimension } = useEditDimensions();

  const {
    data: dimensionsData,
    isLoading: isDimensionLoading,
    isError: isDimensionError,
    refetch: refetchSavedDimensions,
  } = useGetDimension();

  const {
    data: dimensionMeta,
    isLoading: isDimensionMetaLoading,
    isError: isDimensionMetaError,
    refetch: refetchDimensionMeta,
  } = useGetDimensionMeta();

  useEffect(() => {
    const handleOpenDimensionsManagement = () => {
      setDimensionVisible(true);

      // Trigger refetch each time the drawer opens
      refetchSavedDimensions();
      refetchDimensionMeta();
    };
    window.addEventListener(OPEN_DIMENSION_MANAGEMENT_EVENT, handleOpenDimensionsManagement);
    return () => {
      window.removeEventListener(OPEN_DIMENSION_MANAGEMENT_EVENT, handleOpenDimensionsManagement);
    };
  }, [refetchSavedDimensions, refetchDimensionMeta]);

  const handleClose = useCallback(() => {
    setDimensionVisible(false);
  }, []);

  const handleEdit = useCallback<NonNullable<ManagementProps['onEdit']>>(
    async (d: Types.DimensionPayload) => {
      const result = await editDimension({
        dimensions: d,
      });

      apptracker(EDIT_DIMENSION_COMPLETE_DIMENSION_MANAGEMENT, d.operation);

      await refetchSavedDimensions();
      return result;
    },
    [refetchSavedDimensions, editDimension],
  );

  return (
    <div id="dimension-management-container" data-ifc-event={OPEN_DIMENSION_MANAGEMENT_EVENT}>
      <Management
        dimensionVisible={dimensionVisible}
        isDimensionLoading={isDimensionLoading}
        isDimensionError={isDimensionError}
        dimensionsData={dimensionsData as Types.DimensionPayload}
        dimensionMeta={(dimensionMeta || []) as Types.DimensionMeta[]}
        isDimensionMetaLoading={isDimensionMetaLoading}
        isDimensionMetaError={isDimensionMetaError}
        onClose={handleClose}
        onEdit={handleEdit}
      />
    </div>
  );
};
